(function($){

	var storageAvailable = (function(){
		if(!window.sessionStorage){
			return false;
		}
		try{
			window.sessionStorage.setItem("_", "_");
			window.sessionStorage.removeItem("_");
		}
		catch(e){
			return false;
		}
		return true;
	})();
	
	OH.locationHistory = (function(){
		
		if(!storageAvailable){
			return { backed : false };
		}
		
		var formatedURL = function(url){
			if(!url){
				return url;
			}
			url = url.replace(/http[s]?\:\/\//, "");
			url = (n = url.indexOf("/")) >= 0 ? url.slice(n) : url;
			url = (n = url.indexOf("#")) >= 0 ? url.slice(0, n) : url;
			return url;
		};
		var currentURL = formatedURL(location.href);
		var referrer = formatedURL(document.referrer);
		var previousReferrer = window.sessionStorage.getItem(OH.storageKeys.refererHistory);
		
		var backed = currentURL == previousReferrer;
		
		window.sessionStorage.setItem(OH.storageKeys.refererHistory, referrer);
		
		return {
			backed : backed
		};
	})();
	
	OH.getSession = function(key){
		return storageAvailable ? window.sessionStorage.getItem(key) : "";
	}
	OH.setSession = function(key, value){
		if(storageAvailable){
			window.sessionStorage.setItem(key, value);
		}
	}
	
})();